export interface GroupResult<T> {
  key: any;
  count: number;
  items?: T[];
  subGroups?: GroupResult<T>[];
  // Valore aggregato opzionale del gruppo (issue #2971): per gli Ordini Clienti
  // contiene la somma degli ImportoRiga del gruppo. undefined/null = non calcolato.
  somma?: number;
  dataTermine: Date;
  quantita: number;
  quantitaLavorata: number;
  quantitaScartata: number;
}
